module.exports = __webpack_public_path__ + "img/banner_aviation.91a429d0.jpg";